import React from 'react';

import { Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';

import { grey } from '@mui/material/colors';

const NotFound = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant='h1' sx={{mb:2}} >404 - Not Found</Typography>
            <Link to="/" style={{textDecoration:'none'}}><Typography color={grey[500]} variant='caption' sx={{fontSize:"2em"}} >Go to Home</Typography></Link>
            </Box>
        </Box>
    );
}

export default NotFound;
